import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop component that scrolls the window to the top
 * whenever the pathname in the URL changes.
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Add a small delay to allow animations to start first
    const timeoutId = setTimeout(() => {
      // Use requestAnimationFrame to ensure smooth scrolling after React has rendered
      requestAnimationFrame(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "auto"
        });
      });
    }, 100); // Small delay to allow page components to mount and start animations

    // Clean up the timeout if the component unmounts or pathname changes again
    return () => clearTimeout(timeoutId);
  }, [pathname]);

  return null; // This component doesn't render anything
};